<template>
<div class="chapter">
<div class="inner_page">
<a id="page_1"></a>
<p class="half">MAIL BY RAIL</p>
<p class="half1">THE STORY OF THE POST OFFICE AND THE RAILWAYS</p>
<div class="image_containerh">
<img alt="images" src="images/f0001-01.jpg"/>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 01_Halftitle.vue?0a98f620